import React, { useEffect, useState } from 'react';
import './InsurancePaymentStep.scss';
import DynaInput from "../../DynaView/DynaInput";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
import DynaDatePicker from "../../DynaView/DynaDatePicker";
import DynaButton from "../../DynaView/DynaButton";
import numeric from "../../../../utils/NumericFunction";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const InternalResourcesStep = ({ sendData, setSendData }) => {
  const [isDiscountApplied, setIsDiscountApplied] = useState(false);
  const [originalPayAmount, setOriginalPayAmount] = useState(0);

  const [componentData, setComponentData] = useState({
    customerInsurancePrice: "0",
    customerPrePayment: "0",
    customerFirstInternalDate: "",
    customerCountInsurance: 1,
    customerPay: "0",
    customerRealPay: "0",
    customerReceivedPay: "0",
    customerOfferPrice: "0",
    customerReceivedExtra: "0",
  });

  useEffect(() => {
    setComponentData({
      ...componentData,
      customerInsurancePrice: sendData?.customerInsurancePrice === "" ? sendData?.insurancePrice : sendData?.customerInsurancePrice,
      customerPrePayment: sendData?.prePayment,
      customerFirstInternalDate: sendData?.customerFirstInternalDate === "" ? sendData?.firstInternalDate : sendData?.customerFirstInternalDate,
      customerCountInsurance: sendData?.customerCountInsurance === 1 ? sendData?.countInsurance : sendData?.customerCountInsurance,
      customerOfferPrice: "0",
      customerReceivedExtra: "0",
      customerRealPay: sendData?.customerRealPay === "" ? sendData?.prePayment : sendData?.customerRealPay,
      customerReceivedPay: sendData?.customerReceivedPay === "" ? sendData?.prePayment : sendData?.customerReceivedPay,
    });
  }, []);

  useEffect(() => {
    if (componentData?.customerInsurancePrice !== "0") {
      let newPayAmount = +componentData?.customerInsurancePrice - +componentData?.customerRealPay;
      setOriginalPayAmount(newPayAmount);

      let updatedOfferPrice = "0";
      let updatedReceivedExtra = "0";

      // محاسبه تخفیف یا اضافه دریافتی
      if (+componentData?.customerRealPay <= +componentData?.customerReceivedPay) {
        updatedReceivedExtra = (+componentData?.customerReceivedPay - +componentData?.customerRealPay).toString();
        updatedOfferPrice = "0";
      } else {
        updatedOfferPrice = (+componentData?.customerRealPay - +componentData?.customerReceivedPay).toString();
        updatedReceivedExtra = "0";
      }

      // اعمال تخفیف یا اضافه دریافتی در صورت فعال بودن چک‌باکس
      if (isDiscountApplied) {
        newPayAmount = newPayAmount + (+updatedOfferPrice) - (+updatedReceivedExtra);
      }

      setComponentData(prev => ({
        ...prev,
        customerOfferPrice: updatedOfferPrice,
        customerReceivedExtra: updatedReceivedExtra,
        customerPrePayment: (+componentData?.customerRealPay).toString(),
        customerPay: newPayAmount.toString(),
      }));
    }
  }, [
    componentData?.customerInsurancePrice,
    componentData?.customerRealPay,
    componentData?.customerReceivedPay,
    isDiscountApplied,
  ]);

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIsDiscountApplied(isChecked);

    if (!isChecked) {
      // بازگشت به مقدار اصلی در صورت غیرفعال شدن چک‌باکس
      setComponentData(prev => ({ ...prev, customerPay: originalPayAmount.toString() }));
    }
  };

  const insuranceListHandler = () => {
    const customerPay = +componentData?.customerPay;

    let temp = [];
    let i = 0;
    let eachInternalPrice = Math.round((+componentData?.customerPay) / +componentData?.customerCountInsurance);
    while (i < +componentData?.customerCountInsurance) {
      if (i + 1 === +componentData?.customerCountInsurance) {
        if (eachInternalPrice * +componentData?.customerCountInsurance !== customerPay) {
          eachInternalPrice = customerPay - (eachInternalPrice * i);
        }
      }
      temp.push({
        caption: "قسط",
        number: i + 1,
        price: eachInternalPrice,
        date: UtilsFunctions.addMonths(componentData.customerFirstInternalDate, i)
      });
      i = i + 1;
    }
    const total = Math.round(temp.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0));

    setSendData({
      ...sendData, ...componentData,
      customerPay: customerPay,
      customerInstallmentDetails: temp,
      customerInstallmentDetailsTotal: total,
      customerRealPay: componentData?.customerRealPay,
      customerReceivedPay: componentData?.customerReceivedPay
    });
  };

  const detailListInput = (e, price, AIndex) => {
    let temp = [...sendData?.customerInstallmentDetails];
    const customerPay = +componentData?.customerPay;

    let bePayed = 0;
    temp.forEach((item, index) => {
      if (index < AIndex) {
        bePayed = bePayed + +item?.price;
      }
    });

    const AddPrice = Math.round((+customerPay - +UtilsFunctions.removeCommas(e.target.value) - +bePayed) / (temp.length - (AIndex + 1)));

    let LoopPrice = 0;
    temp.forEach((item, index) => {
      if (index === AIndex) {
        item.price = +UtilsFunctions.removeCommas(e.target.value);
        LoopPrice = LoopPrice + +UtilsFunctions.removeCommas(e.target.value);
      } else if (index > AIndex) {
        item.price = +AddPrice;
        LoopPrice = LoopPrice + +AddPrice;
      } else if (index < AIndex) {
        LoopPrice = LoopPrice + item?.price;
      }
    });

    if (temp.length > 0) {
      temp[temp.length - 1].price = temp[temp.length - 1].price + (customerPay - LoopPrice);
    }
    const total = temp.reduce((accumulator, currentValue) => {
      return accumulator + currentValue.price;
    }, 0);

    setSendData({ ...sendData, customerInstallmentDetails: temp, customerInstallmentDetailsTotal: total });
  };

  const dateChangeHandler = (date, AIndex) => {
    let temp = [...sendData?.customerInstallmentDetails];

    temp.forEach((item, index) => {
      if (index === AIndex) {
        item.date = numeric.p2e(date.toLocaleString());
      } else if (index > AIndex) {
        item.date = UtilsFunctions.addMonths(numeric.p2e(date.toLocaleString()), index - AIndex);
      }
    });
    setSendData({ ...sendData, customerInstallmentDetails: temp });
  };

  return (
    <div className="insurance-payment">
      <div className={"grid-side"}>

        <div style={{ gridColumn: "1 / -1" }}>
          <DynaInput label={"مبلغ کل حق بیمه"}
            name={"customerInsurancePrice"}
            className={"solid-dyna-input"}
            placeholder={"مبلغ کل حق بیمه را وارد کنید"}
            hasComma={true}
            value={UtilsFunctions.addCommas(componentData?.customerInsurancePrice)}
            disabled
            type={"text"}
            setDataFromComponent={(data) => {
              setComponentData({ ...componentData, ...data });
            }}
          />
        </div>

        <DynaInput label={"مبلغ پیش پرداخت واقعی"}
          name={"customerRealPay"}
          className={"solid-dyna-input"}
          placeholder={"مبلغ پرداختی مشتری را وارد کنید"}
          hasComma={true}
          value={UtilsFunctions.addCommas(+componentData?.customerRealPay)}
          type={"text"}
          setDataFromComponent={(data) => {
            if (+data?.customerRealPay <= componentData?.customerInsurancePrice) {
              setComponentData({ ...componentData, ...data });
            }
          }}
          disabled
        />

        <DynaInput label={"مبلغ پیش پرداخت دریافتی"}
          name={"customerReceivedPay"}
          className={"solid-dyna-input"}
          placeholder={"مبلغ پرداختی مشتری را وارد کنید"}
          hasComma={true}
          value={UtilsFunctions.addCommas(+componentData?.customerReceivedPay)}
          type={"text"}
          setDataFromComponent={(data) => {
            if (+data?.customerReceivedPay <= componentData?.customerInsurancePrice) {
              setComponentData({ ...componentData, ...data });
            }
          }}
        />

        <div className='check-box' style={{ gridColumn: "1 / -1" }}>
          <input
            type="checkbox"
            id='checkBox'
            checked={isDiscountApplied}
            onChange={handleCheckboxChange}
          />
          <label htmlFor="checkBox">مبلغ تخفیف یا اضافه دریافتی به جمع اقساط اضافه شود.</label>
        </div>

        <DynaInput label={"تخفیف"}
          name={"customerOfferPrice"}
          className={"solid-dyna-input"}
          placeholder={"تخفیف را وارد کنید"}
          hasComma={true}
          disabled
          value={UtilsFunctions.addCommas(componentData?.customerOfferPrice)}
          type={"text"}
        />

        <DynaInput label={"اضافه دریافتی"}
          name={"customerReceivedExtra"}
          className={"solid-dyna-input"}
          placeholder={"تخفیف را وارد کنید"}
          hasComma={true}
          disabled
          value={UtilsFunctions.addCommas(componentData?.customerReceivedExtra)}
          type={"text"}
        />

        <DynaInput label={"جمع اقساط"}
          name={"customerPay"}
          className={"solid-dyna-input"}
          placeholder={"مبلغ پرداختی مشتری را وارد کنید"}
          hasComma={true}
          disabled
          value={UtilsFunctions.addCommas(componentData?.customerPay)}
          type={"text"}
        />

        <DynaDatePicker label={"تاریخ شروع قسط"}
          name={"customerFirstInternalDate"}
          className={"solid-dyna-input"}
          value={componentData?.customerFirstInternalDate}
          setDataFromComponent={(data) => {
            setComponentData({ ...componentData, ...data });
          }}
        />

        <DynaInput label={"حداکثر تعداد اقساط"}
          name={"customerCountInsurance"}
          className={"solid-dyna-input"}
          placeholder={"حداکثر تعداد اقساط را وارد کنید"}
          hasComma={true}
          value={componentData?.customerCountInsurance}
          type={"number"}
          setDataFromComponent={(data) => {
            {
              data.customerCountInsurance !== 0 ? setComponentData({ ...componentData, ...data }) :
                setComponentData({ ...componentData, customerCountInsurance: 1 });
            }
          }}
        />

        <DynaInput label={"مبلغ هر قسط"}
          name={"total"}
          className={"solid-dyna-input"}
          placeholder={"مبلغ هر قسط را وارد کنید"}
          hasComma={true}
          disabled
          value={UtilsFunctions.addCommas((Math.round((+componentData?.customerPay) / +componentData?.customerCountInsurance)))}
          type={"text"}
        />

        <DynaButton className={"insurance-button"} type={"button"} onClick={insuranceListHandler}>اعمال</DynaButton>
      </div>

      <ul className={"grid-side list-box"}>
        {sendData?.customerInstallmentDetails.length > 0 && sendData?.customerInstallmentDetails.map((item, index) =>
          <li key={index + "J"}>
            <div className={"inline-text"}>
              <h3>{item?.caption + " " + (index + 1)}</h3>
              <h4>تاریخ :</h4>
              <DatePicker
                onChange={(e) => dateChangeHandler(e, index)}
                value={item?.date}
                calendar={persian}
                placeholder="تاریخ را انتخاب کنید"
                locale={persian_fa}
                calendarPosition="bottom-right"
                hideOnScroll
              />
            </div>
            <div className={"inline-text"}>
              <h4>مبلغ :</h4>
              <input value={UtilsFunctions.addCommas(item?.price)} type={"text"}
                onChange={(e) => detailListInput(e, item?.price, index)} />
            </div>
          </li>
        )}
      </ul>

      <div className={"show-total"}>
        <h4>جمع اقساط</h4>
        <h3>{UtilsFunctions.addCommas(sendData?.customerInstallmentDetailsTotal)}</h3>
      </div>
    </div>
  );
};

export default InternalResourcesStep;